import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ChipView extends React.PureComponent {
    render() {
        const chipView = (
            <div className={styles.content_list}>
                <Chip id="261002" type="struct" title="嘉宾名字及嘉宾图片维护" groupName="嘉宾名字及嘉宾图片维护">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261003" type="struct" title="首页预告内容维护" groupName="首页预告内容维护">
                    <div className={styles.chip_item} />
                </Chip>
                <div className={styles.chip_item} />
                <Chip id="288903" type="recommend" title="嘉宾1视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288904" type="recommend" title="嘉宾2视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288905" type="recommend" title="嘉宾3视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288906" type="recommend" title="嘉宾4视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288907" type="recommend" title="嘉宾5视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288908" type="recommend" title="嘉宾6视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288909" type="recommend" title="嘉宾7视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288910" type="recommend" title="嘉宾8视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288911" type="recommend" title="嘉宾9视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288912" type="recommend" title="嘉宾10视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288913" type="recommend" title="嘉宾11视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288914" type="recommend" title="嘉宾12视频列表" groupName="嘉宾1视频列表">
                    <div className={styles.chip_item} />
                </Chip>
                <div className={styles.chip_item} />
                <Chip id="261004" type="struct" title="嘉宾1攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261005" type="struct" title="嘉宾2攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261006" type="struct" title="嘉宾3攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261007" type="struct" title="嘉宾4攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261008" type="struct" title="嘉宾5攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261009" type="struct" title="嘉宾6攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261010" type="struct" title="嘉宾7攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261011" type="struct" title="嘉宾8攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261012" type="struct" title="嘉宾9攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261013" type="struct" title="嘉宾10攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261014" type="struct" title="嘉宾11攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261015" type="struct" title="嘉宾12攒劲花絮" groupName="嘉宾1攒劲花絮">
                    <div className={styles.chip_item} />
                </Chip>
                <div className={styles.chip_item} />
                <Chip id="261016" type="struct" title="广告权益" groupName="广告权益">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261017" type="struct" title="往期回顾" groupName="广告权益">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="261018" type="struct" title="二维码列表" groupName="广告权益">
                    <div className={styles.chip_item} />
                </Chip>
            </div>
        );

        return ReactDOM.createPortal(chipView, document.body);
    }
}

export default errorBoundary(ChipView);
